/**
 * Legal document versions & effective dates.
 *
 * Single source of truth for the Terms of Service, Privacy Policy, and Data
 * Processing Agreement (DPA) version metadata. Drives BOTH the "Version X ·
 * Effective …" line rendered on each legal page (via LegalDocShell) AND the
 * consent record written onto companies/{cid}.legal at signup (redeemSignupInvite,
 * from the versions the sign-up page sends).
 *
 * A document revision is one edit here: bump the version + effective date and it
 * flows to the displayed line and to the next signup's recorded consent.
 *
 * See PRD/PRD_LegalConsent.md (C4). Mirrors the export idiom of src/config/plans.js.
 */

/** Current version of each legal document. */
export const LEGAL_VERSIONS = {
  terms: "1.0",
  privacy: "1.1",
  dpa: "1.0",
};

/** Effective date (ISO yyyy-mm-dd) of each legal document's current version. */
export const LEGAL_EFFECTIVE = {
  terms: "2026-06-09",
  privacy: "2026-10-13",
  dpa: "2026-06-09",
};

/**
 * Format an ISO yyyy-mm-dd effective date for display, e.g. "9 June 2026".
 * Parsed as UTC so the rendered day never shifts by timezone.
 */
export function formatEffective(iso) {
  const [y, m, d] = String(iso).split("-").map(Number);
  // Fail soft: a missing/garbage date renders blank, never "Invalid Date".
  if (![y, m, d].every(Number.isFinite)) return "";
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}
